import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
const HelpTopicContext = createContext(undefined);
export const HelpTopicProvider = ({ children }) => {
    const [activeTopic, setActiveTopic] = useState(null);
    const [isHelpDrawerOpen, setIsHelpDrawerOpen] = useState(false);
    const setHelpTopic = useCallback((topic) => setActiveTopic(topic), []);
    const openHelpDrawer = useCallback(() => setIsHelpDrawerOpen(true), []);
    const closeHelpDrawer = useCallback(() => setIsHelpDrawerOpen(false), []);
    const value = useMemo(() => ({ activeTopic, setHelpTopic, isHelpDrawerOpen, openHelpDrawer, closeHelpDrawer }), [activeTopic, setHelpTopic, isHelpDrawerOpen, openHelpDrawer, closeHelpDrawer]);
    return _jsx(HelpTopicContext.Provider, { value: value, children: children });
};
export const useHelpTopicContext = () => {
    const ctx = useContext(HelpTopicContext);
    if (!ctx) {
        throw new Error('useHelpTopicContext must be used within a HelpTopicProvider');
    }
    return ctx;
};
// Lets a page with its own tabs register which one is active, so the help
// drawer can show tab-specific content instead of the page's generic content.
// Clears itself on unmount/tab change so a stale topic never leaks to another page.
export const useHelpTopic = (topic) => {
    const { setHelpTopic } = useHelpTopicContext();
    useEffect(() => {
        setHelpTopic(topic ?? null);
        return () => setHelpTopic(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [topic]);
};
